import { createSlice } from '@reduxjs/toolkit';

import { DeliveryPreferenceState } from 'models/DeliveryPreference';

import { getDeliveryPreferences, putDeliveryPreferences } from './deliveryPreference.thunk';

export const initialState: DeliveryPreferenceState = {
  data: null,
  loading: false,
  error: null,
};

export const deliveryPreferenceSlice = createSlice({
  name: 'deliveryPreference',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // get delivery preference
    builder.addCase(getDeliveryPreferences.pending, (state) => {
      state.data = null;
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getDeliveryPreferences.fulfilled, (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(getDeliveryPreferences.rejected, (state, action) => {
      state.data = null;
      state.loading = false;
      state.error = action.payload ? action.payload : state.error;
    });

    // put delivery preference
    builder.addCase(putDeliveryPreferences.pending, (state) => {
      state.data = null;
      state.loading = true;
      state.error = null;
    });
    builder.addCase(putDeliveryPreferences.fulfilled, (state, action) => {
      if (action.payload && state.data?.location) state.data.location = action.payload;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(putDeliveryPreferences.rejected, (state, action) => {
      state.data = null;
      state.loading = false;
      state.error = action.payload || action.error;
    });
  },
});

export { getDeliveryPreferences, putDeliveryPreferences };
